import { Component, Input, OnInit } from '@angular/core';
import { Platform, PopoverController } from '@ionic/angular';
@Component({
  selector: 'app-info-pasar-pagina',
  templateUrl: './info-pasar-pagina.component.html',
  styleUrls: ['./info-pasar-pagina.component.scss'],
  standalone: false
})
export class InfoPasarPaginaComponent implements OnInit {
  @Input() test;

  isMobile: boolean = null;

  constructor(
    private popoverController: PopoverController,
    private platform: Platform
  ) { }

  ngOnInit() {
    this.checkDevice();
  }

  private checkDevice() {
    let platforms = this.platform.platforms();
    this.isMobile = !!(platforms.find(type => type == "mobile"));
  }


  public close(): void {
    this.popoverController.dismiss();
  }
}
